import config from 'js/app/config';

export const createCanonicalEntArticleLink = (slug: string): string => {
  return `${config.url.domain}/enterprise/articles/${slug}`;
};
